import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { UNLOAD_EXAMPLE } from './constants';
import {
  UnloadExampleError,
  UnloadExampleDataActionTypes,
  UnloadExampleState,
} from './types';

const initialState: UnloadExampleState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: UnloadExampleDataActionTypes,
  ): UnloadExampleState => {
    switch (action.type) {
      case UNLOAD_EXAMPLE + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case UNLOAD_EXAMPLE + SUCCESS: {
        draft.status = fulfilled;
        break;
      }
      case UNLOAD_EXAMPLE + FAILURE: {
        draft.status = rejected;
        draft.error = (action as UnloadExampleError).error;
        break;
      }
      case UNLOAD_EXAMPLE + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
